// Import api models.
import ProducerAgency from './ProducerAgency';

export default class ParentProducerAgency extends ProducerAgency {

	public isOverridden: boolean| null = null;

	public constructor() {
		super();
	}
};